import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/web/incredible-web.webp";

function Banner(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>
                Acquire Incredible Web Solutions from a Professional Website
                Development Company
              </h2>
              <p className="main_para">
                Our website development Dubai team develops client-focused
                solutions for clients around the globe. TekRevol is a renowned
                digital transformation and website development company with
                years of experience providing leading custom web development
                services. Our feature-rich, robust, exquisitely designed, and
                exceptionally built web solutions make us the premier website
                development company in Dubai.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="dubai website development"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
